import { TFunction } from "@impero-com/common/utils/i18n";
import { type StatusBadgeStatus } from "@impero-com/ui";

import { Friction, FrictionData } from "api/generated/model";

import { ControlActivityTableRow } from "../types";

export function buildHealthDetails(
    row: ControlActivityTableRow,
    t: TFunction
): string[] | undefined {
    const details: string[] = [];
    if (row.isOverdue) {
        details.push(t("ControlResult_Health_Overdue"));
    }
    if (row.rejectionCount > 0) {
        details.push(
            row.rejectionCount > 1
                ? t("ControlResult_Health_RejectedCount", {
                      count: row.rejectionCount,
                  })
                : t("ControlResult_Health_Rejected")
        );
    }
    if (row.reopenCount > 0) {
        details.push(
            row.reopenCount > 1
                ? t("ControlResult_Health_ReopenedCount", {
                      count: row.reopenCount,
                  })
                : t("ControlResult_Health_Reopened")
        );
    }
    return details.length > 0 ? details : undefined;
}

export function buildFrictionLabel(
    friction: Friction,
    t: TFunction
): string | null {
    switch (friction) {
        case Friction.HighFriction:
            return t("ControlResult_Friction_HighFriction");
        case Friction.Friction:
            return t("ControlResult_Friction_Friction");
        case Friction.NoFriction:
            return null;
    }
}

export function buildHealthLabels(
    frictionData: FrictionData,
    t: TFunction
): string[] {
    const frictionLabel = buildFrictionLabel(frictionData.friction, t);
    return [frictionLabel ?? t("ControlResult_Health_Clean")];
}

export function buildHealthStatus(
    frictionData: FrictionData
): StatusBadgeStatus {
    switch (frictionData.friction) {
        case Friction.HighFriction:
            return "highFriction";
        case Friction.Friction:
            return "friction";
        case Friction.NoFriction:
            return "noFriction";
    }
}

export const HEALTH_LABEL_SEPARATOR = " · ";
